import * as React from 'react';
import { VERDICT_API, type Verdict } from './types.ts';

type GetApi = <T>(name: string) => Promise<T>;

// The verdict service once its provider has registered it, kept per
// `getApi` so a component mounted later gets it on its first render.
const found = new WeakMap<GetApi, Verdict>();

/** The verdict service; undefined until the provider registers. */
export function useVerdict(getApi: GetApi): Verdict | undefined {
  const [verdict, setVerdict] = React.useState<Verdict | undefined>(() => found.get(getApi));
  React.useEffect(() => {
    if (verdict) return;
    let live = true;
    void getApi<Verdict>(VERDICT_API).then((v) => {
      found.set(getApi, v);
      if (live) setVerdict(v);
    });
    return () => {
      live = false;
    };
  }, [getApi, verdict]);
  return verdict;
}
